// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DvgN","col":"styles_col__1M-Cx","actions":"styles_actions__1QNFN","conflict":"styles_conflict__1ygTg"};